export const environment = {
  production: false,
  SYSTEM_API_URL: 'https://saigonpharma.com/api/system/',
  MAIN_API_URL: 'https://saigonpharma.com/api/main/',
  VERSION: 'v1.0.0',
};
